import { NavigationGuard } from 'vue-router'
import { Feature } from '@/types/generated/graphql'
import { apolloClient } from '@/plugins/vue-apollo'

import AUTHORIZATION_QUERY from '@/graphql/auth/authorizations.gql'
import { Authorizations } from '@/packages/authorization'

async function fetchAuthorizations(): Promise<Authorizations> {
  const { data } = await apolloClient.query({
    query: AUTHORIZATION_QUERY,
    fetchPolicy: 'cache-first',
  })

  return new Authorizations(data.authorizations)
}

export async function authorizedTo(feature: Feature) {
  const authorizations = await fetchAuthorizations()

  return authorizations.allowed(feature)
}

export const featureGuard: NavigationGuard = async (to, from, next) => {
  if (to.meta.feature) {
    const allowed = await authorizedTo(to.meta.feature)
    if (!allowed) {
      next({ name: 'NotFound' })
    }
  }
  next()
}
